// biome-ignore-all lint/performance/noBarrelFile: This is okay - because we want to export a single file
"use client"

import debounce from "lodash.debounce"
import { useEffect, useState } from "react"

export function withDebounce<
  DebouncedFunction extends (...parameters: ReadonlyArray<unknown>) => void,
>(debouncedFunction: DebouncedFunction, timeoutMilliseconds: number) {
  let timerHandle: ReturnType<typeof setTimeout> | undefined

  return (...parameters: Parameters<typeof debouncedFunction>) => {
    clearTimeout(timerHandle)
    timerHandle = setTimeout(
      () => debouncedFunction(parameters),
      timeoutMilliseconds,
    )
  }
}
// More about the two ways of debouncing: https://stackoverflow.com/a/61140811
// https://www.developerway.com/posts/debouncing-in-react
export function useDebouncedCallback<T>(
  callback: (args: T) => unknown,
  delay: number,
) {
  return debounce(callback, delay)
}

// Copied from the useDebounce hook from @uidotdev/usehooks
export function useDebouncedValue(
  value: number | string,
  delay: number | string,
) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, Number(delay))

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
